import raf             from 'raf';
import debounce        from 'lodash.debounce';
import Promise         from 'promise-polyfill';

const selector = '[data-js-filter]';
const listFilter = function(el, app) {

    const $el = $(el);
    const $window = $(window);
    const itemSelector = '[data-js-filter-item]';
    const singleSelect = $el.data( 'single' ) || false;
    const disableEvent = $el.data( 'disable-event' ) || false;
    const href = $el.data( 'href' );
    const namespace = $el.data( 'js-namespace' );
    const iconCheckCircleMarkup = '<svg viewBox="0 0 512 512" class="Ge-Icon"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon_small-yes"></use></svg>';

    const init = function() {
        registerEvents();

        $window.on( 'filterUpdated.' + namespace, ( event, value ) => {
            console.log( event );
            console.log( value );
        } )
    };

    const select = function select( $element ) {
        $element
            .prepend( $( iconCheckCircleMarkup ) )
            .removeClass( 'Ge-Btn--outline' )
            .addClass( 'Ge-List-Filter-Item--active Ge-Btn--blue' );
    };

    const deselect = function deselect( $element ) {
        $element
            .removeClass( 'Ge-List-Filter-Item--active Ge-Btn--blue' )
            .addClass( 'Ge-Btn--outline' )
            .find( '.Ge-Icon' )
                .remove();
    };

    const handleItemClick = function( event ) {
        const $target = $( event.currentTarget );
        console.log("handleItemClick", event.currentTarget);
        
        
        if ( singleSelect ) {
            deselect( $el.find( '.Ge-List-Filter-Item--active' ) );
        }

        if ( $target.hasClass( 'Ge-List-Filter-Item--active' ) ) {
            deselect( $target );
        } else {
            select( $target );
            const hrefTarget = $target.data( 'href' );
        }

        if(!disableEvent) {
            $window.trigger( 'filterUpdated.' + namespace, $.makeArray( [ $el.find( '.Ge-List-Filter-Item--active' ).map( ( index, element ) => {
                return $( element ).data( 'value' );
            } ) ] ) );
        }
    };

    const registerEvents = function() {
        $el.on( 'click', itemSelector, handleItemClick );
    };

    return {
        init: init()
    };
};

listFilter.selector = selector;

export default listFilter;
